import EventBus from "eventing-bus"

const initialBoardNum = 3

let scene = null,
  modelsArr = [],
  trucksArr = [],
  wheelsArr = [],
  camera = null,
  controls = null,
  currSection = null,
  prevSection = null,
  currBoard = 4,
  currTruck = 2,
  currWheel = 2,
  swipeDirection,
  isEndBoardZoomed = false,
  itemsInCart = 0

const SECTION_CHANGED = "sectionChanged",
  BOARD_CHANGED = "boardChanged",
  TRUCK_CHANGED = "truckChanged",
  WHEEL_CHANGED = "wheelChanged",
  SWIPE_DETECTED = "swipeDetected",
  PLAY_PRODUCT_ZOOM = "playProductZoom",
  ADD_TO_CART_PRESSED = "addToCartPressed",
  ITEMS_IN_CART = "itemsInCart",
  CART_BTN_PRESSED = "cartBtnPressed",
  PAUSE_THREE_TICK = "pauseThreeTick"

export const getScene = () => {
  return scene
}

export const setScene = (scn) => {
  scene = scn
}

export const getModelsArr = () => {
  return modelsArr
}

export const setModelsArr = (mod) => {
  modelsArr = mod
}

export const getTruckModelsArr = () => {
  return trucksArr
}

export const setTruckModelsArr = (mod) => {
  trucksArr = mod
}

export const getWheelModelsArr = () => {
  return wheelsArr
}

export const setWheelModelsArr = (mod) => {
  wheelsArr = mod
}

export const getCamera = () => {
  return camera
}

export const setCamera = (cam) => {
  camera = cam
}

export const getControls = () => {
  return controls
}

export const setControls = (cont) => {
  controls = cont
}

export const getCurrSection = () => {
  return currSection
}

export const setCurrSection = (num) => {
  prevSection = currSection
  currSection = num
  EventBus.publish(SECTION_CHANGED)
}

export const getPrevSection = () => {
  return prevSection
}

export const getCurrBoard = () => {
  return currBoard
}

export const setCurrBoard = (num) => {
  currBoard = num
  EventBus.publish(BOARD_CHANGED)
}

export const getCurrTruck = () => {
  return currTruck
}

export const setCurrTruck = (num) => {
  currTruck = num
  EventBus.publish(TRUCK_CHANGED)
}

export const getCurrWheel = () => {
  return currWheel
}

export const setCurrWheel = (num) => {
  currWheel = num
  EventBus.publish(WHEEL_CHANGED)
}

export const getSwipeDirection = () => {
  return swipeDirection
}

export const setSwipeDirection = (dir) => {
  swipeDirection = dir
  EventBus.publish(SWIPE_DETECTED)
}

export const getItemsInCart = () => {
  return itemsInCart
}

export const setItemsInCart = (num) => {
  itemsInCart = num
  EventBus.publish(ITEMS_IN_CART)
}

export const zoomBoardView = (bool) => {
  isEndBoardZoomed = bool
  EventBus.publish(PLAY_PRODUCT_ZOOM, bool)
}

export const getIsEndBoardZoomed = () => {
  return isEndBoardZoomed
}

export const constants = {
  SECTION_CHANGED,
  BOARD_CHANGED,
  TRUCK_CHANGED,
  WHEEL_CHANGED,
  SWIPE_DETECTED,
  PLAY_PRODUCT_ZOOM,
  ADD_TO_CART_PRESSED,
  ITEMS_IN_CART,
  CART_BTN_PRESSED,
  PAUSE_THREE_TICK,
}
